module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/1-0c3abdd291cd0840dbb3f7497ae2ae3a.jpg";